import React, { Fragment } from 'react'
import { ProductItemType } from '../../types'
import ProductList from './productList'
interface Props {
  dataSourceList: ProductItemType[]
  listType: number
}

function ProductListTab(props: Props) {
  const { dataSourceList, listType } = props

  return (
    <Fragment>
      <ProductList dataSource={dataSourceList} listType={listType} />
    </Fragment>
  )
}

export default ProductListTab
